export default "__VITE_ASSET__ZPcUTyXA__"